<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{!statusId ? 'Add' : 'Update'}} Status</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="statusForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px"> 
            <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Status Name</mat-label>
                <input matInput placeholder="Status Name" formControlName="statusName" type="text">
                <mat-error
                  *ngIf="statusForm.controls['statusName'].touched && statusForm.controls['statusName'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="5"
                formControlName="description"
              ></textarea>
              <mat-error
                *ngIf="
                  statusForm.controls['description'].touched &&
                  statusForm.controls['description'].hasError('required')
                "
              >
                This is required field.
              </mat-error>
            </mat-form-field>
         </div>

         <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
          <button mat-button type="button" class="sub-button" (click)="submit()">{{!statusId ? 'Add' : 'Update'}}</button>
          <button class="can-button" (click)="this.location.back()" mat-button>Cancel</button>
        </div>
           
           
          </form>
    </div>
  </div>
  